<template>
  <v-app>
    <v-progress-linear
        :indeterminate="loading"
        height="2" color="orange"
        style="margin: 0;z-index: 9999;position: fixed;"
    />
    <router-view></router-view>
    <!-- -->
    <v-snackbar
        :timeout="snackbar.timeout"
        :top="true"
        :multi-line="true"
        v-model="snackbar.show"
        :color="snackbar.color"
    >
      {{ snackbar.text }}
      <v-btn flat icon class="mx-0" @click.native="snackbar.show = false">
        <v-icon color="white">close</v-icon>
      </v-btn>
    </v-snackbar>

    <v-dialog v-model="timeout" persistent max-width="320">
      <v-card>
        <v-card-text>
          <p>会话超时，请输入 <span class="primary--text">{{ name }} ({{ username }})</span> 的密码</p>
          <v-text-field
              type="password"
              label="密码"
              :hint="msg"
              v-model="passwd"
              persistent-hint
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="checkPasswd">确定</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'

import md5 from 'md5'

export default {
  name: 'App',
  data() {
    return {
      loading: false,
      // 上次操作的时间戳
      lastTimestamp: Date.now(),
      timeout: false,
      passwd: '',
      msg: '',
      tryNum: 0,

      snackbar: {
        show: false,
        timeout: 10000,
        text: '',
        color: 'error'
      }
    }
  },
  computed: {
    ...mapGetters([
      'authenticated',
      'name',
      'username',
      'password'
    ])
  },

  // 注册异步请求响应的公共回调
  created() {
    // 响应拦截器
    const vm = this;
    //这段代码为原有拦截代码
    Vue.axios.interceptors.response.use(
        function (response) {
          // 正常响应
          return response;
        },
        function (error) {
          // Do something with response error
          // console.log(error);
          const msg = error.response.data.message || "";
          vm.snackbar.text = "服务器错误[" + error.response.status + "]: " + msg;
          vm.snackbar.show = true;
          return Promise.reject(error);
        }
    );

    //以下这段代码为deepseek为上述拦截器报错误提供的修复方案，暂时不采用
    //Unhandled Promise Rejection: TypeError: undefined is not an object (evaluating 'e.response.data')
    /*Vue.axios.interceptors.response.use(
        function (response) {
          // 正常响应
          return response;
        },
        function (error) {
          // Do something with response error
          let errorMessage = '发生未知错误'; // 默认错误信息

          // 安全地处理错误对象
          if (error.response) {
            // 情况1：请求成功发出，服务器返回了错误状态码（4xx, 5xx）
            // 现在可以安全地访问 error.response
            const msg = error.response.data?.message || ""; // 使用可选链操作符更安全
            errorMessage = `服务器错误[${error.response.status}]: ${msg}`;
          } else if (error.request) {
            // 情况2：请求已经发出，但没有收到任何响应（网络中断、超时、CORS失败）
            // error.request 是 XMLHttpRequest 对象
            errorMessage = '网络连接错误：无法连接到服务器或请求超时。';
            // 你可以进一步区分超时等错误
            // if (error.code === 'ECONNABORTED') { errorMessage = '请求超时'; }
          } else {
            // 情况3：在设置请求时发生了错误（例如，错误的请求配置）
            errorMessage = `请求配置错误: ${error.message}`;
          }

          // 显示错误提示
          vm.snackbar.text = errorMessage;
          vm.snackbar.show = true;

          // 仍然将错误传递下去，以便具体的请求调用方可以进行自己的错误处理
          return Promise.reject(error);
        }
    );*/


    // 请求拦截器
    Vue.axios.interceptors.request.use(cfg => {
      // 更新最后一次操作的时间
      vm.lastTimestamp = Date.now();
      return cfg
    }, err => {
      window.console.log(err)
    })

    this.$router.beforeEach(
        (to, from, next) => {
          // console.log("in App $router.beforeEach");

          this.loading = true;
          next();
        });

    this.$router.afterEach(
        () => {
          this.loading = false;
        });

    // 10 秒钟检查一次会话是否超时
    setInterval(this.isBusy, 10000);
  },
  methods: {
    checkPasswd() {
      if (this.password === md5(this.passwd)) {
        this.lastTimestamp = Date.now();
        this.timeout = false;
        this.passwd = '';
        this.msg = '';
      } else {
        this.msg = '密码错误，请重试！'
      }
    },
    isBusy() {
      // 会话超时 30 分钟
      let timeout = (Date.now() - this.lastTimestamp) > 30 * 60 * 1000;
      if (timeout) {
        // window.console.log('timeout');
        this.timeout = true
      }
    }
  }
}
</script>
<style>
.application {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
</style>

